import pino from 'pino'

const logger =
  process.env.NODE_ENV === 'development'
    ? pino({
        level: process.env.PINO_LOG_LEVEL ?? 'debug',
        transport: {
          target: 'pino-pretty',
        },
        serializers: {
          err: pino.stdSerializers.err,
        },
      })
    : pino({
        formatters: {
          level(level) {
            return { level }
          },
        },
        serializers: {
          err: pino.stdSerializers.err,
        },
        level: process.env.PINO_LOG_LEVEL ?? 'info',
      })

export default logger
